// import libs
import store from '@/store'
import { getData, postData } from '@core/utils/http/general'
import { ref } from '@vue/composition-api'

// alumnos de calificaciones profesor
export const reportImpresoCalif = (plan, curso, periodo) => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 10,
    id_plan: plan,
    id_curso: curso,
    periodo,
    obj: 1,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wsreportes')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

// alumnos con calificaciones de chyj
export const reportImpresoResolucion = periodo => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 11,
    id_periodo: periodo,
    obj: 1,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wsreportes')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

// cabecera de calificaciones profesor
export const cabecerakardex = (plan, curso) => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 1,
    idplan: plan,
    idcurso: curso,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wsreportes')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
export const cabeceraAlumno = matricula => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 5,
    data: matricula,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wsadinterna')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
export const reportImpresoKardex = (mat, pl) => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 6,
    data: { matricula: mat, plan: pl },
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wsadinterna')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
export const especialidadAlumno = matricula => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 24,
    data: matricula,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wsalumno')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
export const useReportesCatalogos = () => {
  const planOptions = ref([])
  const planOptionsPromise = () => new Promise((resolve, reject) => {
    getData({ action: 15 }, 'wspublico')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data.planes)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })
  const statusOptions = ref([])
  const statusOptionsPromise = () => new Promise((resolve, reject) => {
    getData({ action: 7, token: store.state.cuenta.session.token }, 'wsreportes')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  const cursosOptions = ref([])
  const cursosOptionsPromise = periodo => new Promise((resolve, reject) => {
    getData({ action: 3, token: store.state.cuenta.session.token, periodo }, 'wscursos')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data.cursos)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })
  const reporteGralPromise = (plan, periodo, tiposAlum, tipoperiodo) => new Promise((resolve, reject) => {
    getData({
      action: tiposAlum,
      token: store.state.cuenta.session.token,
      id_plan: plan,
      tipoperiodo,
      periodo,
    }, 'wsreportes')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })
  const reporteEspecPromise = (plan, curso, tiposAlum) => new Promise((resolve, reject) => {
    const data = new FormData()
    data.append('task', 'wsreportes')
    data.append('token', store.state.cuenta.session.token)
    data.append('origin', process.env.VUE_APP_ORIGIN_API)
    data.append('action', tiposAlum)
    data.append('id_plan', plan)
    data.append('id_curso', curso)

    postData(data)
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })
  const reporteFinalPromise = (plan, curso, periodo) => new Promise((resolve, reject) => {
    getData({
      action: 9,
      token: store.state.cuenta.session.token,
      id_plan: plan,
      periodo,
      id_curso: curso,
      obj: 1,
    }, 'wsparticipantes')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })
  const reporteAspirantesPromise = ({
    plan, inicial, final, columnas, periodo_id,
  }) => new Promise((resolve, reject) => {
    getData({
      action: 4,
      token: store.state.cuenta.session.token,
      idplan: plan,
      periodo_ini: inicial,
      periodo_fin: final,
      periodo_id,
      datos: columnas,
    }, 'wsreportes')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })
  return {
    // Promise fetch options
    planOptionsPromise,
    cursosOptionsPromise,
    reporteGralPromise,
    reporteFinalPromise,
    reporteEspecPromise,
    reporteAspirantesPromise,
    statusOptionsPromise,

    // Options
    planOptions,
    cursosOptions,
    statusOptions,
  }
}
